var $cdfa2fbe7ad5fd49$exports = {};
// Upgrades the contact form so a successful send stays on the page.
//
// This is an enhancement, not the mechanism. Without it the form still works:
// it posts natively, Netlify accepts it, and the sender lands on Netlify's own
// generic success page. Off-brand, but nothing is lost. Everything here only
// improves on that.
//
// Netlify Forms does not exist on the dev server, so a submit locally will fail
// and show the error branch. That is expected; the real path can only be tested
// on a deploy preview or in production.
const $cdfa2fbe7ad5fd49$var$form = document.querySelector(".contact-form");
const $cdfa2fbe7ad5fd49$var$status = document.querySelector(".contact-status");
if ($cdfa2fbe7ad5fd49$var$form && $cdfa2fbe7ad5fd49$var$status) {
    const setStatus = (message, modifier)=>{
        $cdfa2fbe7ad5fd49$var$status.className = `contact-status ${modifier}`;
        $cdfa2fbe7ad5fd49$var$status.textContent = message;
    };
    $cdfa2fbe7ad5fd49$var$form.addEventListener("submit", async (event)=>{
        event.preventDefault();
        const submitBtn = $cdfa2fbe7ad5fd49$var$form.querySelector("button[type='submit']");
        submitBtn.disabled = true;
        submitBtn.textContent = "Sending...";
        setStatus("", "");
        try {
            // Netlify reads a form-encoded body posted to any path on the site; the
            // page's own URL is the conventional target. FormData carries every named
            // field, which includes the hidden form-name that tells Netlify which
            // form this is, and the honeypot, which Netlify needs to see empty.
            const response = await fetch("/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams(new FormData($cdfa2fbe7ad5fd49$var$form)).toString()
            });
            // Netlify answers a form post with a redirect to its success page, which
            // fetch follows; a 404 here means the form was never detected at deploy
            // time. Treat anything non-2xx as a failure rather than reporting a
            // success that did not happen.
            if (!response.ok) throw new Error(`Netlify returned ${response.status}`);
            // Removed, not hidden and not replaced.
            //
            // Not left in place: a filled-in copy of an already-sent message invites
            // a second identical send. Not replaceWith: that would move the live
            // region in the DOM and drop focus to <body> with nothing announced.
            // And not form.hidden either — the region is a sibling, so removing the
            // form cannot disturb it, and remove() is the one option no stylesheet
            // can override. hidden was defeated by .contact-form's own display: flex.
            $cdfa2fbe7ad5fd49$var$form.remove();
            setStatus("Thank you \u2014 your message is on its way. A reply will come to the address you gave.", "is-sent");
            // The region is the only thing left to look at, and focus has to land
            // somewhere deliberate.
            $cdfa2fbe7ad5fd49$var$status.focus();
        } catch (error) {
            submitBtn.disabled = false;
            submitBtn.textContent = "Send";
            // The address is in the message on purpose: if the form is broken, the
            // useful thing is the way around it, not an apology.
            setStatus("That did not send. Please try again, or write to santosh@greatmahabharataquiz.com directly.", "is-error");
        }
    });
}


//# sourceMappingURL=contact.b2c79641.js.map
